<!-- Reprovada -->
<div class="timeline-badge">
    <a><em class="fa fa-circle"></em></a>
</div>

<h4 *ngIf="timelineActive">{{ timeline.dataHora | date:'HH:mm'}} <small>{{ timeline.dataHora | date:'dd/MM/yyyy'}}</small></h4>

<div class="timeline-panel" [ngClass]="{'timeline-panel-disabled': !timelineActive}">

    <div class="step">
        <span class="icon"></span>
        <h2>{{ timeline.tituloStatus }}</h2>
        <span>{{ timeline.subTituloStatus}}</span>

        <div *ngIf="timelineActive" class="specifications">
            <div class="col-xs-6 icon-stats">
            </div>
        </div>

        <div *ngIf="!timelineActive"><br /></div>

    </div>

</div>
